<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester semester-nonall ssystem college department sclass keyword="學號、學生姓名">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.type" id="sex" label="身分別">
                            <div is="option" value="">全部</div>
                            <div is="option" value="A">A類</div>
                            <div is="option" value="B">B類</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload" :input="input">
                    <b-button variant="warning" @click="Add('Anshin1')">安心學習(強化語言學習)</b-button>
                    <b-button variant="warning" @click="Add('Anshin2')">安心學習(加強課業輔導)</b-button>
                    <b-button variant="warning" @click="Add('Anshin3')">安心學習(自律學習)</b-button>
                    <b-button variant="warning" @click="Add('Janchr')">展翅課程</b-button>
                    <b-button variant="warning" @click="Add('Shuji')">暑期專業證照</b-button>
                    <b-button variant="warning" @click="Add('License')">證照補助</b-button>
                </btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學號-學生姓名</th>
                            <th>A類</th>
                            <th>B類</th>
                            <th>安心學習<br />(強化語言學習)</th>
                            <th>安心學習<br />(加強課業輔導)</th>
                            <th>安心學習<br />(自律學習)</th>
                            <th>展翅課程</th>
                            <th>暑期專業證照</th>
                            <th>證照補助</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.StudentNo">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.StudentNo" /></td>
                        <td data-th="學號-學生姓名">{{item.StudentNo}}-{{item.StudentName}}</td>
                        <td data-th="A類">{{item.A|true}}</td>
                        <td data-th="B類">{{item.B|true}}</td>
                        <td data-th="安心學習(強化語言學習)">{{item.Anshin1|true}}</td>
                        <td data-th="安心學習(加強課業輔導)">{{item.Anshin2|true}}</td>
                        <td data-th="安心學習(自律學習)">{{item.Anshin3|true}}</td>
                        <td data-th="展翅課程">{{item.Janchr|true}}</td>
                        <td data-th="暑期專業證照">{{item.Shuji|true}}</td>
                        <td data-th="證照補助">{{item.License|true}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <inputmodal id="input" sample="/template/scholarship.xlsx" url="/api/scholarship/listexcel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import { master } from '@/views';
    export default master({
        name: 'scholarship',
        api: '/api/scholarship/',
        filters: { true: function (value) { return value ? '✔' : ''; } },
        methods: {
            Add: function (type) {
                if (!this.query.syear) {
                    return this.$bvToast.toast('請輸入學年度', { title: '錯誤', variant: 'danger', solid: true });
                }
                this.$http({ method: 'put', url: '/api/scholarship/put', data: { SYear: this.query.syear, Semester: this.query.semester, Type: type, StudentNo: this.deleteItem } })
                    .then(() => { this.reload(); })
            }
        }
    });
</script>

<style>
</style>